import { Box, Button, styled } from "@mui/material";

const Wrapper = styled("div")`
  margin-bottom: 6%;
  padding: 0 3%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

const StyledButton = styled(Button)`
  width: 100%;
  height: 10vh;
  font-size: 3vw;
`;

interface FooterProps {
  text: string;
  disabled?: boolean;
  onClick: (value: boolean) => void;
}

export const Footer = ({ text, disabled, onClick }: FooterProps) => {
  return (
    <Wrapper>
      <Box>
        <StyledButton
          variant="contained"
          disabled={disabled}
          onClick={() => onClick(true)}
        >
          {text}
        </StyledButton>
      </Box>
    </Wrapper>
  );
};
